const OPERAND_COLORS = [
  0xD63AD4,
  0x9AD63A
]

export default class Stack extends Phaser.Group {
  constructor (game, memory, stackHeight, stackWidth, inventory) {
    super(game, null, 'Stack')

    this.memory = memory
    this.stackHeight = stackHeight
    this.stackWidth = stackWidth

    this.pointerY = stackHeight
    this.pointerX = 0
    this.count = 0

    this.operandGraphics = []

    this.pointerGraphics = this.game.add.graphics(0, 0, this)
    this.pointerGraphics.beginFill(0xffffff)
    this.pointerGraphics.drawPolygon([0, 0, 3, 3, -3, 3])
    this.pointerGraphics.endFill()

    this.updatePointer()

    for (let i = 0; i < 2; i++) {
      const graphic = new Phaser.Graphics(game, 0, 0)
      graphic.beginFill(0, 0)
      graphic.lineStyle(1, OPERAND_COLORS[i], 1)
      graphic.drawRect(0, 0, 13, 13)
      graphic.endFill()
      graphic.alpha = 0

      this.operandGraphics.push(graphic)
      this.add(graphic)
    }
  }

  push (value) {
    if (this.pointerY === 0 && this.pointerX === 0) {
      throw new Error('Stack overflow')
    }

    const offsetCoords = this.getOffsetCoords(1)
    this.pointerX = offsetCoords.offsetX
    this.pointerY = offsetCoords.offsetY

    this.memory.set(this.pointerY, this.pointerX, value)
    this.count++

    this.drawOperandMarkers()
    this.updatePointer()
  }

  pop () {
    if (this.pointerY === this.stackHeight && this.pointerX === 0) {
      throw new Error('Stack underflow')
    }

    const value = this.memory.get(this.pointerY, this.pointerX)
    this.memory.set(this.pointerY, this.pointerX, 0)

    const offsetCoords = this.getOffsetCoords(-1)
    this.pointerX = offsetCoords.offsetX
    this.pointerY = offsetCoords.offsetY

    this.count--

    this.drawOperandMarkers()
    this.updatePointer()

    return value
  }

  onItemChanged (item) {
    this.currentItem = item

    this.drawOperandMarkers()
  }

  updatePointer () {
    const xPos = this.pointerY === 12 ? 4 : this.pointerX
    const yPos = this.pointerY === 12 ? 12 : this.pointerY + 1
    this.game.add.tween(this.pointerGraphics)
      .to({
        x: xPos * 16,
        y: yPos * 16 - 3
      }, 150, Phaser.Easing.Linear.None, true)
  }

  drawOperandMarkers () {
    if (!this.currentItem) {
      return
    }

    const numOperands = this.currentItem.operands.length

    for (let i in this.operandGraphics) {
      const graphic = this.operandGraphics[i]
      const { offsetX, offsetY } = this.getOffsetCoords(-i)

      const destX = offsetX * 16 + 1
      const destY = offsetY * 16 + 1

      this.game.add.tween(this.operandGraphics[i]).to(
        {x: destX, y: destY}, 150, Phaser.Easing.Linear.None, true
      )

      if (!this.currentItem || i >= numOperands || offsetY >= this.stackHeight ||
          (numOperands === 2 && i === 0 && offsetY === this.stackHeight - 1 && offsetX === this.stackWidth - 1)) {
        graphic.alpha = 0
      } else {
        graphic.alpha = 1
      }
    }
  }

  getOffsetCoords (offset) {
    let offsetX = this.pointerX
    let offsetY = this.pointerY

    if (offset > 0) {
      while (offset > 0) {
        offsetX--
        if (offsetX < 0) {
          offsetY--
          offsetX = this.stackWidth - 1
        }

        offset--
      }
    } else {
      while (offset < 0) {
        offsetX++
        if (offsetX >= this.stackWidth) {
          offsetY++
          offsetX = 0
        }

        offset++
      }
    }

    return { offsetX, offsetY }
  }
}
